import React from 'react';
import styled from 'styled-components/macro';
import { Row, Icon } from 'antd';

import Button from 'components/Button/Button';
import Heading from 'components/Heading/Heading';
import Description from 'components/Description/Description';
import WebBackgroundImage from './images/web-bg.svg';
import MobileBackgroundImage from './images/mobile-bg.svg';

const MainContainer = styled(Row)`
  background: url(${MobileBackgroundImage}) no-repeat center bottom;
  background-size: cover;
  height: 900px !important;
  padding-top: 32%;
  padding-bottom: 8%;
  min-height: 900px;

  @media (min-width: 768px) {
    padding-top: 8%;
    background: url(${WebBackgroundImage}) no-repeat center top;
    background-size: cover;
    display: 'flex';
    align-items: 'center';
  }

  @media (min-width: 1600px) {
    background: url(${WebBackgroundImage}) no-repeat center center;
    background-size: 100% auto;
    height: 60vh !important;
  }
`;

const ContentDiv = styled.div`
  width: 100%;
  margin-top: 8%;
  @media (min-width: 768px) {
    width: 42%;
    margin-top: 0;
  }
  @media (min-width: 1600px) {
    margin-top: 8%;
  }
`

const RenoCalculator = () => {
  return (
    <MainContainer>
      <ContentDiv>
        <Heading color="white">Reno Calculator</Heading>
        <Description size="large" color="white">
          Get an estimation for the cost of renovation now!
        </Description>
        <Button type="cta" size="large" toUrl="/reno-calculator">
          Try now <Icon type="right" />
        </Button>
      </ContentDiv>
    </MainContainer>
  );
};

export default RenoCalculator;
